import { render, staticRenderFns } from "./default-section.vue?vue&type=template&id=387b632c&lang=pug&"
import script from "./default-section.vue?vue&type=script&lang=js&"
export * from "./default-section.vue?vue&type=script&lang=js&"
import style0 from "./default-section.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports